// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"8a6e3bd9","885":"45170d85","895":"c176cfaf"}[chunkId] + ".chunk.js";
};